// Path: src/components/admin/AdminMenu.tsx
// Added Referrals menu item for /admin/referrals
// Path: src/components/admin/AdminMenu.tsx
// Updated to add a "Live Support" menu item navigating to /admin/live-support.
// Path: src/components/admin/AdminMenu.tsx
// refactor: Add mode and onLinkClick props for responsive layout usage.
// 06/07/25 12:40 PM +07

import React from "react";
import { Menu } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import {
  UserOutlined,
  FileDoneOutlined,
  ShoppingCartOutlined,
  CheckCircleOutlined,
  LinkOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import styled from "styled-components";
import { useFirebase } from "../dev/Firebase/Firebase";

const StyledMenu = styled(Menu)`
  &.ant-menu-horizontal {
    background: #3552fc;
    color: #fff;
    border-bottom: none;

    .ant-menu-item-selected,
    .ant-menu-item:hover {
      background: #ff8800 !important;
      border-bottom: none !important;
    }
    .ant-menu-item, .ant-menu-submenu-title {
      color: #fff;
    }
  }

  &.ant-menu-vertical {
    border-right: none;
    .ant-menu-item-selected {
       background: #ff8800 !important;
       color: #fff !important;
    }
  }
`;

interface AdminMenuProps {
  mode: 'horizontal' | 'vertical';
  onLinkClick?: () => void; // Optional callback for closing drawer
}

const AdminMenu: React.FC<AdminMenuProps> = ({ mode, onLinkClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { signOut } = useFirebase();

  const handleNavigation = (path: string) => {
    navigate(path);
    if (onLinkClick) {
      onLinkClick();
    }
  };
  
  const handleSignOut = async () => {
    try {
      await signOut();
      handleNavigation("/login");
      console.log("Sign out completed, navigated to /login");
    } catch (error) {
      console.error("Sign out failed:", error);
    }
  };

  const menuItems = [
    { key: "/admin/users/all", icon: <UserOutlined />, label: "Dashboard", onClick: () => handleNavigation("/admin/users/all") },
    { key: "/admin/users/verify", icon: <FileDoneOutlined />, label: "Verify users", onClick: () => handleNavigation("/admin/users/verify") },
    { key: "/admin/evaluation", icon: <CheckCircleOutlined />, label: "Evaluate users", onClick: () => handleNavigation("/admin/evaluation") },
    { key: "/admin/referrals", icon: <LinkOutlined />, label: "Referrals", onClick: () => handleNavigation("/admin/referrals") },
    { key: "/admin/live-support", icon: <MessageOutlined />, label: "Live Support", onClick: () => handleNavigation("/admin/live-support") },
    { key: "/admin/orders", icon: <ShoppingCartOutlined />, label: "Orders", onClick: () => handleNavigation("/admin/orders") },
    { key: "signout", label: "Sign out", onClick: handleSignOut },
  ];

  return (
    <StyledMenu
      theme={mode === 'horizontal' ? 'dark' : 'light'}
      mode={mode}
      selectedKeys={[location.pathname]}
      items={menuItems}
      // Removed the global onClick handler in favor of individual item onClick
    />
  );
};

export default AdminMenu;